// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"VideoPlayer-module--wrapper--3lo56","controls":"VideoPlayer-module--controls--3DcK7"};